import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { _post } from "../../Config/axiosInstance";

function UserpasswordReset() {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleReset = async () => {
    setMessage("");
    setError("");
    setLoading(true);
    setOpenConfirm(false);

    try {
      const response = await _post("resetuserpassword"); // No payload

      if (response.status === 200) {
        setMessage("Password reset successfully for user.");
      } else {
        setError("Password reset failed.");
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred while resetting the password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", mt: 5 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Reset Password for "user"
        </Typography>

        {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => setOpenConfirm(true)}
          disabled={loading}
        >
          {loading ? "Resetting..." : "Reset Password"}
        </Button>

        {/* Confirmation Dialog */}
        <Dialog
          open={openConfirm}
          onClose={() => setOpenConfirm(false)}
        >
          <DialogTitle>Confirm Password Reset</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to reset the password for user <strong>"user"</strong>?
              This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenConfirm(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleReset} color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Box>
  );
}

export default UserpasswordReset;
